import { createSelector } from '@ngrx/store';

import { membersState } from '../root';

export const getMemberResetForgottenPasswordState = createSelector(membersState, (members) => members.forgottenPasswordReset);
